var map = {
	"./bg_alternate-login.svg": 41979,
	"./bg_home.svg": 66742,
	"./bg_login-mobile.svg": 73897,
	"./bg_login.svg": 42538,
	"./imersys.svg": 87493,
	"./logo_sagah.svg": 5445,
	"./v-chip.svg": 80892
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 75801;